import react, {useEffect, useState} from "react";
import CruiseControl  from "./CruiseControl";

import ContactsSelectable from "../Contacts/ContactsSelectable";

export default function CruiseControlSetUp(){


    return(
    <>
        <CruiseControl />
        <ContactsSelectable />
    
    
    
    </>);
}